var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraspShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 131,
    viewBox: "0 0 372 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5974_41954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.721,
    cy: 65.3827,
    rx: 135.5,
    ry: 15,
    fill: "#263E5E",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.721 65.3827C320.721 65.7368 320.561 66.1333 320.153 66.5783C319.742 67.026 319.107 67.4916 318.23 67.9659C316.478 68.914 313.861 69.8439 310.446 70.7377C303.624 72.5231 293.731 74.136 281.479 75.4923C256.982 78.2042 223.126 79.8827 185.721 79.8827C148.316 79.8827 114.46 78.2042 89.963 75.4923C77.7111 74.136 67.8175 72.5231 60.9958 70.7377C57.581 69.8439 54.9643 68.914 53.2117 67.9659C52.335 67.4916 51.6996 67.026 51.289 66.5783C50.8807 66.1333 50.7209 65.7368 50.7209 65.3827C50.7209 65.0286 50.8807 64.632 51.289 64.187C51.6996 63.7394 52.335 63.2737 53.2117 62.7994C54.9643 61.8514 57.581 60.9215 60.9958 60.0277C67.8175 58.2423 77.7111 56.6294 89.963 55.2731C114.46 52.5612 148.316 50.8827 185.721 50.8827C223.126 50.8827 256.982 52.5612 281.479 55.2731C293.731 56.6294 303.624 58.2423 310.446 60.0277C313.861 60.9215 316.478 61.8514 318.23 62.7994C319.107 63.2737 319.742 63.7394 320.153 64.187C320.561 64.632 320.721 65.0286 320.721 65.3827Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5974_41954",
    x: 0.220947,
    y: 0.38269,
    width: 371,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_5974_41954"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraspShadow);
export default __webpack_public_path__ + "static/media/grasp_shadow.f2f662f2bd74108ab936c288b11f78d7.svg";
export { ForwardRef as ReactComponent };